module.exports = __webpack_public_path__ + "img/YellowArrows_right.9e704b26.svg";